module.exports = __webpack_public_path__ + "static/news-1ca818e0943acee394f5358ca4800e94.png";